import Modal from "@/components/common/modal";
import { Button, Heading } from "@elaniintc/goes-design-system";
import type { AcceptButtonDetails } from "./types";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onAccpet: () => void;
  title: string;
  description: string;
  acceptButtonDetails: AcceptButtonDetails;
  children: React.ReactNode;
}

const ActionModal = ({
  isOpen,
  onClose,
  onAccpet,
  title,
  description,
  acceptButtonDetails,
  children,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title=""
      modalContentClassName="max-w-[520px] w-full p-0 m-0"
    >
      <div className="px-8 pb-8 w-full">
        <div className="text-center pb-8">
          <Heading variant="h2">{title}</Heading>
          <p className="font-normal text-md leading-3xl text-body">
            {description}
          </p>
        </div>
        {children}
        <div className="w-full flex gap-3 pt-2">
          <div className="w-1/2">
            <Button
              size="lg"
              type="button"
              className="w-full"
              variant="tertiary"
              onClick={onClose}
              disabled={acceptButtonDetails.isLoading}
            >
              Cancelar
            </Button>
          </div>
          <div className="w-1/2">
            <Button
              size="lg"
              type="button"
              className="w-full"
              variant={acceptButtonDetails.variant}
              onClick={onAccpet}
              disabled={
                acceptButtonDetails.disabled || acceptButtonDetails.isLoading
              }
              isLoading={acceptButtonDetails.isLoading}
            >
              {acceptButtonDetails.label}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ActionModal;
